
import img from '../../files/system/No_Data.png';

function InfoNoData({ text }) {
    return (
        <div className="row mt-15 mb-15">
            <div className="col-md-12 text-center fw-bold fs-3 opacity-50 d-flex justify-content-center align-items-center">
                <img src={img} height={30} className='mr-15 ' />
                {text}
            </div>
        </div>
    )
}

export default InfoNoData;